import { makeStyles } from '@material-ui/core/styles'

export const wikiBrowserStyle = makeStyles(theme => ({
  backButton: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonIcon: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonPadding: {
    paddingLeft: theme.spacing(1)
  },
  root: {
    width: '100%'
  },
  divider: {
    height: 1,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    background: theme.palette.geoColors.contextBar.dark
  },
  disabledListItem: {
    cursor: 'default',
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: '#00000000'
    }
  },
  documentItem: {
    '& .MuiTypography-body1': {
      fontSize: '0.9rem'
    }
  },
  list: {
    paddingBottom: 0
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  topMargin: {
    marginTop: theme.spacing(2)
  },
  nestedListSubheader: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '48px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.geoColors.headerText.main,
    userSelect: 'none',
    zIndex: 0
  },
  nestedListSubheaderIcon: {
    float: 'right',
    paddingTop: '0.5rem'
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    fontSize: '0.8rem',
    color: theme.palette.geoColors.text.light
  },
  searchButton: {
    position: 'absolute',
    color: theme.palette.geoColors.headerText.main,
    right: 40,
    top: 0
  },
  searchButtonIcon: {
    color: theme.palette.geoColors.headerText.main
  },
  sectionListItem: {
    margin: 0,
    marginTop: theme.spacing(4),
    padding: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: theme.palette.primary.main
  },
  title: {
    '& .MuiTypography-body1': {
      fontSize: '1.1rem'
    }
  }
}))
